var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubphaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74171 0C2.88966 0 2.07251 0.31607 1.47002 0.87868C0.867528 1.44129 0.529053 2.20435 0.529053 3V24C0.529053 24.7956 0.867528 25.5587 1.47002 26.1213C2.07251 26.6839 2.88966 27 3.74171 27H13.3797C14.2317 27 15.0489 26.6839 15.6514 26.1213C16.2538 25.5587 16.5923 24.7956 16.5923 24V15H26.2303C27.0823 15 27.8995 14.6839 28.502 14.1213C29.1045 13.5587 29.4429 12.7956 29.4429 12V3C29.4429 2.20435 29.1045 1.44129 28.502 0.87868C27.8995 0.31607 27.0823 0 26.2303 0H3.74171ZM16.5923 12H26.2303V3H16.5923V12ZM3.74171 15V24H13.3797V15H3.74171ZM3.74171 12H13.3797V3H3.74171V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubphaseIcon);
export default __webpack_public_path__ + "static/media/subphase-icon.16d2e17779a006fd2214a29712977c20.svg";
export { ForwardRef as ReactComponent };